import { Typography, Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import homeAboutImg from '../../assets/img/about/home-about.webp';

const Homeabout = () => {
    return (
        <div
            className="about-area"
            style={{
                paddingTop: '30px',
                paddingBottom: '32px',
                backgroundColor: '#e8e4dc',
                minHeight: '500px'
            }}
        >
            <div className="container">
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        gap: 4,
                        alignItems: 'center'
                    }}
                >
                    {/* Left Content */}
                    <Box sx={{ flex: 1 }}>
                        <Typography
                            variant="h2"
                            sx={{
                                fontWeight: '700',
                                color: '#10274a',
                                mb: 3,
                                fontSize: '2rem',
                                lineHeight: 1.3,
                            }}
                        >
                            Why Royale Spaces Is the Most Trusted Real Estate Name in Amaravati
                        </Typography>

                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: '600',
                                color: '#1a3a4a',
                                mb: 3,
                                fontSize: { xs: '18px', md: '20px' },
                                // fontFamily: '"Rubik", sans-serif'
                            }}
                        >
                            Royale Spaces UK-Based Real Estate Company Now in Hyderabad & Amaravati.
                        </Typography>

                        <Typography
                            sx={{
                                color: '#333',
                                mb: 2,
                                fontSize: '15px',
                                lineHeight: 1.8,
                                // fontFamily: '"Rubik", sans-serif'
                            }}
                        >
                            Royale Spaces is a UK-based real estate company now operating in Hyderabad and Amaravati. We are a top real estate agency in Amaravati, offering open plots in Amaravati and residential plots for sale in Amaravati across the capital region. With verified properties and transparent processes, we make every property investment in Amaravati secure and rewarding. Royale Spaces is now creating high-value investment opportunities in two of South India's most promising regions - Hyderabad and Amaravati.
                        </Typography>

                        <Typography
                            sx={{
                                color: '#333',
                                mb: 2,
                                fontSize: '15px',
                                lineHeight: 1.8,
                                // fontFamily: '"Rubik", sans-serif'
                            }}
                        >
                            As one of the leading real estate consultants in Amaravati, Royale Spaces helps buyers, sellers, and investors explore the best opportunities in Andhra Pradesh’s capital region. Whether you are searching for APCRDA approved plots in Amaravati, residential land, or commercial properties, we guide you with clarity and confidence.
                        </Typography>

                        <Typography
                            sx={{
                                color: '#333',
                                mb: 4,
                                fontSize: '15px',
                                lineHeight: 1.8,
                                fontFamily: '"Rubik", sans-serif'
                            }}
                        >
                            Backed by local expertise and deep market insights, Royale Spaces connects you with verified plots, clear documentation, and genuine pricing — ensuring every deal is safe, profitable, and future-ready.
                        </Typography>

                        <Button
                            component={Link}
                            to="/about"
                            sx={{
                                backgroundColor: '#c9a961',
                                color: '#fff',
                                px: 4,
                                py: 1.5,
                                fontSize: '14px',
                                fontWeight: '600',
                                letterSpacing: '1px',
                                textTransform: 'uppercase',
                                '&:hover': {
                                    backgroundColor: '#b89850'
                                }
                            }}
                        >
                            HOW WE WORK
                        </Button>
                    </Box>

                    {/* Right Card */}
                    <Box sx={{ flex: { xs: 1, md: 0.5 }, width: '100%' }}>
                        <Box
                            sx={{
                                borderRadius: 2,
                                overflow: 'hidden',
                                boxShadow: '0px 4px 12px rgba(0,0,0,0.15)'
                            }}
                        >
                            {/* Image Section */}
                            <Box
                                sx={{
                                    height: '250px',
                                    backgroundColor: '#5a7a8a',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundImage: `url(${homeAboutImg})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center'
                                }}
                            >
                                <Typography
                                    variant="h5"
                                    sx={{
                                        color: '#fff',
                                        fontWeight: '600',
                                        textAlign: 'center',
                                        textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
                                    }}
                                >
                                    SPEAK TO US TODAY
                                </Typography>
                            </Box>

                            {/* Search Section and Contact Button */}
                            <Box
                                sx={{
                                    backgroundColor: '#e8e8e8',
                                    p: 4,
                                    textAlign: 'center'
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    sx={{
                                        color: '#7a7a7a',
                                        mb: 3,
                                        fontSize: '18px',
                                        fontWeight: '500',
                                        letterSpacing: '1px'
                                    }}
                                >
                                    SEARCH FOR YOUR LOCAL BRANCH
                                </Typography>

                                <Button
                                    component={Link}
                                    to="/contact"
                                    fullWidth
                                    sx={{
                                        backgroundColor: '#c62828',
                                        color: '#fff',
                                        py: 2,
                                        fontSize: '16px',
                                        fontWeight: '600',
                                        letterSpacing: '1px',
                                        '&:hover': {
                                            backgroundColor: '#b71c1c'
                                        }
                                    }}
                                >
                                    CONTACT US
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </div>
        </div>
    );
};

export default Homeabout;
